import { render, staticRenderFns } from "./UploadDocumentAttachmentDialog.vue?vue&type=template&id=3bac4d44&scoped=true&lang=pug&"
import script from "./UploadDocumentAttachmentDialog.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentAttachmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocumentAttachmentDialog.vue?vue&type=style&index=0&id=3bac4d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac4d44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VCardText,VCardTitle,VDivider,VIcon,VSpacer})
